import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';

const SelectionGroupItem = ({ title , text , value , scope , aside , handleChange , isChecked , disabled , dataT  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "selection-group-item"
    }, /*#__PURE__*/ React.createElement("input", {
        className: "selection-group-item__input",
        name: scope,
        id: title,
        type: "radio",
        value: value,
        "data-t": dataT,
        checked: isChecked,
        "aria-checked": isChecked,
        disabled: disabled || undefined,
        onChange: handleChange
    }), /*#__PURE__*/ React.createElement("label", {
        className: "selection-group-item__label",
        htmlFor: title
    }, /*#__PURE__*/ React.createElement("div", {
        className: "selection-group-item__main"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        className: "selection-group-item__title"
    }, title), text && /*#__PURE__*/ React.createElement("span", {
        className: "selection-group-item__text"
    }, text)), aside && /*#__PURE__*/ React.createElement("div", {
        className: "selection-group-item__aside"
    }, aside)));
};

export { SelectionGroupItem as default };
//# sourceMappingURL=SelectionGroupItem.js.map
